import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCYrnx2jnzNmdeRADl0WOMMSX0dqgJ_aYA",
  authDomain: "projetakip-7a261.firebaseapp.com",
  projectId: "projetakip-7a261",
  storageBucket: "projetakip-7a261.firebasestorage.app",
  messagingSenderId: "453820700722",
  appId: "1:453820700722:web:9e6bd3cfc8149e54d3442b"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
